import { CILL_HEIGHT_MM, FRAME_BORDER_MM, THRESHOLD_HEIGHT_MM } from '../layout/doorLayout';

/**
 * Development-preview dimension bounds only. Not manufacturing or product rules.
 * Minimums leave room for frame, mandatory threshold, optional cill, and a slab opening.
 */
const MIN_STACK_MM =
  FRAME_BORDER_MM + THRESHOLD_HEIGHT_MM + CILL_HEIGHT_MM + FRAME_BORDER_MM;

export const DEV_DOOR_WIDTH_MIN_MM = 500;
export const DEV_DOOR_WIDTH_MAX_MM = 2000;
export const DEV_DOOR_HEIGHT_MIN_MM = Math.max(1500, MIN_STACK_MM + 200);
export const DEV_DOOR_HEIGHT_MAX_MM = 3000;

export function parseDevelopmentDimension(
  raw: string,
  min: number,
  max: number
): number | null {
  const trimmed = raw.trim();
  if (!/^\d+$/.test(trimmed)) return null;
  const value = Number(trimmed);
  if (!Number.isFinite(value) || value < min || value > max) return null;
  return value;
}

export function constrainDevelopmentDimension(
  raw: string,
  min: number,
  max: number,
  fallback: number
): number {
  const numeric = Number(raw.trim());
  if (!Number.isFinite(numeric)) return fallback;
  return Math.min(max, Math.max(min, Math.round(numeric)));
}
